import { Text, VFlow } from 'bold-ui'
import { CpfOrCns } from 'components/CpfOrCns'
import { css } from 'emotion'
import { Fragment } from 'react'
import { formatDate } from 'util/date/formatDate'
import { ParticipanteModel } from 'view/atividade-coletiva/model-atividadeColetiva'
import { getNomeCidadao } from 'view/atividade-coletiva/utils-atividadeColetiva'

import { ParticipanteCidadaoIdadeInfo } from './ParticipanteCidadaoIdadeInfo'

interface ParticipanteCidadaoInfoProps {
  participante: ParticipanteModel
  dataAtividade: LocalDate | undefined
}

export const ParticipanteCidadaoInfo = (props: ParticipanteCidadaoInfoProps) => {
  const { dataAtividade, participante } = props
  const cidadao = participante.cidadao ?? participante.cidadaoParticipante
  const cidadaoDataObito = participante.cidadao?.dataObito

  return (
    <VFlow vSpacing={0.1} style={styles.container}>
      <Text fontWeight='bold'>{getNomeCidadao(cidadao)?.titleCase()}</Text>
      <CpfOrCns cpf={cidadao.cpf} cns={cidadao.cns} defaultText='' />
      <Text>
        {cidadao.dataNascimento && (
          <Fragment>
            <ParticipanteCidadaoIdadeInfo participante={participante} dataAtividade={dataAtividade} />
            {` | `}
          </Fragment>
        )}
        {`${cidadao.sexo?.capitalize() ?? '-'}`}
      </Text>
      {cidadaoDataObito && (
        <Fragment>
          <Text fontWeight='bold' color='danger'>
            Óbito em:{' '}
          </Text>
          <Text>{formatDate(cidadaoDataObito)}</Text>
        </Fragment>
      )}
    </VFlow>
  )
}

const styles = {
  container: css`
    margin: 1rem 0;
  `,
}
